




























































import Vue from 'vue';
import { mapActions } from 'vuex';
import {
  ICategoryShowObject,
  IUserCategoryObject,
} from '../../../../../shared/types';
import api from '../../../api';

interface IData {
  mode: number;
  name: string;
  description: string;
}

interface IMethods {
  goToHome: () => void;
  toggleMode: () => void;
  save: () => Promise<void>;
  deleteCategory: () => Promise<void>;
}

interface IComputed {
  actionText: string;
}

interface IProps {
  category: IUserCategoryObject | null,
  shows: ICategoryShowObject[],
}

export default Vue.extend<IData, IMethods, IComputed, IProps>({
  name: 'CategoryHeader',

  props: {
    category: {
      type: Object,
      default: null,
    },

    shows: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    mode: 0,

    name: '',
    description: '',
  }),

  computed: {
    actionText() {
      return this.mode === 0 ? 'Edit' : 'Save';
    },
  },

  methods: {
    ...mapActions('navigation', [
      'goToHome',
    ]),

    toggleMode() {
      if (this.mode === 1) {
        this.save();
      } else if (this.category) {
        this.name = this.category.name;
        this.description = this.category.description;
      }

      this.mode = this.mode === 0 ? 1 : 0;
    },

    async save() {
      if (this.category && 'id' in this.category) {
        await api.category.edit(
          this.category.id,
          this.name,
          this.description,
        );
      }

      this.$emit('edited');
    },

    async deleteCategory() {
      if (this.category && 'id' in this.category) {
        await api.category.deleteOne(this.category.id);
      }

      this.goToHome();
    },
  },
});
